import { Component, OnInit, Inject, HostListener } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { StepComponent } from '../stepcomponent.class';
import { IConfig, IDescriptionValuePair } from '../../../../../lib/interfaces/config.interface';
import {
  PreviousEmploymentInfo,
  CreditApplicationConfig,
  LookupMappingInformation
} from '../../../../../lib/interfaces/credit-application-config.interface';
import { AdditionalInfoComponent } from '../additional-info/additional-info.component';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import { CreditAppService } from '../../../../services/credit-app.service';
import { StepType } from '../../../../enum/step-type.enum';
import { getLookupMappings, validateBothNotZero, validateAllFormFields, getBackButton} from '../../../../utils/utils.functions';
import {CurrentEmployer} from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, ServerError } from '../../../../../lib/actions/analytics.action';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';
import createNumberMask from '../../../../../lib/utils/numberMask.functions';
import { NotificationsService } from '../../../../services/notifications.service';
import { INotification, NotificationType } from '../../../../interfaces/notification.interface';
import { HeapIoService } from '../../../../services/heap-io.service';

@Component({
  selector: 'dt-previous-employment-info',
  templateUrl: './previous-employment-info.component.html',
  styleUrls: ['./previous-employment-info.component.scss'],
  standalone: false
})
export class PreviousEmploymentInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  previousEmploymentInfoForm: UntypedFormGroup;
  numberMask: any;
  phoneMask: Array<string | RegExp>;
  prevEmploymentInfoConfigData: PreviousEmploymentInfo;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  employmentStatusTypes: IDescriptionValuePair[];
  employmentTypes: IDescriptionValuePair[];
  yearsOnJobType: IDescriptionValuePair[];
  monthsOnJobType: IDescriptionValuePair[];
  incomePeriodIntervalType: IDescriptionValuePair[];
  employmentTypeEnumForMappingToJobType: IDescriptionValuePair[];
  formSubmitAttempt = false;
  prevJobTitleCleared = true;
  prevEmployerPhoneCleared = true;
  prevGrossSalaryCleared = true;
  prevEmployerNameCleared = true;
  isCustomerRetired = false;
  namePattern: string;
  wordOnlyRegexp: string;
  phonePattern: string;
  formSubmitted = false;
  isSaving = false;
  isBuyNow = false;
  SubPage = '';
  isLegacyCreditApp:boolean = false;

  constructor(private fb: UntypedFormBuilder,
              @Inject('config') public SitecoreConfig: IConfig,
              private nextComponentService: NextComponentService,
              private previousComponentService: PreviousComponentService,
              private creditAppService: CreditAppService,
              private analyticsEventService: AnalyticsEventService,
              private notificationService: NotificationsService,
              private readonly heapIoService: HeapIoService) { }

isMobile() {
  return window.innerWidth < 767 || (window.innerWidth > 768 && window.innerHeight < 480);
}

 isLandscape() {
   return window.innerWidth > window.innerHeight && (window.innerWidth > 768 && window.innerWidth <= 1024);
 }

 public get employment(): CurrentEmployer {
    if (this.creditAppService &&
      this.creditAppService.CreditApplication[this.type] &&
      this.creditAppService.CreditApplication[this.type].financialInformation &&
      this.creditAppService.CreditApplication[this.type].financialInformation.previousEmployer) {
        const previousEmployer: CurrentEmployer = {
          ...this.creditAppService.CreditApplication[this.type].financialInformation.previousEmployer
        };

          if(this.employmentTypeEnumForMappingToJobType){
        if (Number(previousEmployer.salary) === 0 && this.employmentTypeEnumForMappingToJobType ||
          !this.employmentTypeEnumForMappingToJobType.some(v => v.Value === previousEmployer.jobType)) {
          previousEmployer.jobType = '';
        }
      }

      if(this.employmentStatusTypes){
        if (Number(previousEmployer.salary) === 0 ||
          !this.employmentStatusTypes.some( v => v.Value === previousEmployer.employmentStatus)) {
          previousEmployer.employmentStatus = '';
        }
      }

      if(this.incomePeriodIntervalType){
        if (Number(previousEmployer.salary) === 0 ||
          !this.incomePeriodIntervalType.some(v => v.Value === previousEmployer.frequency)) {
          previousEmployer.frequency = '';
        }
      }
        if (previousEmployer.salary) {
          previousEmployer.salary = previousEmployer.salary.toString();
        }
        return previousEmployer;
      }
    return {
        employerName: null,
        employmentStatus: '',
        frequency: null,
        jobTitle: null,
        jobType: null,
        monthsAtEmployer: null,
        phoneNumber: null,
        salary: null,
        yearsAtEmployer: null
      };
  }

  ngOnInit() {
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    this.namePattern = '^[A-Za-z\\s\'\`\’]*$';
    this.wordOnlyRegexp = '^[A-Za-z0-9\\s\'\`\’]';
    this.phonePattern = '^[(]{1}[0-9]{3}[)]{1}[ ]{1}[0-9]{3}[-]{1}[0-9]{4}$';

    if (
      this.SitecoreConfig &&
      this.SitecoreConfig.Sitecore &&
      this.SitecoreConfig.Sitecore.CreditApplicationConfig
    ) {
      this.prevEmploymentInfoConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig.PreviousEmploymentInfo;
      this.creditAppConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.SitecoreConfig.Sitecore.LookupMappingInformation;
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.SubPage = this.SitecoreConfig.Sitecore.SubPage ? this.SitecoreConfig.Sitecore.SubPage : '';
      this.isLegacyCreditApp = this.SitecoreConfig.Sitecore.isLegacyCreditApp;
      if(this.isLegacyCreditApp){
        this.updateCtas();
      }
    }

    this.employmentStatusTypes = getLookupMappings(this.lookupMappingInfo, 'EmploymentStatusType');
    this.employmentTypes = getLookupMappings(this.lookupMappingInfo, 'EmploymentType');
    this.yearsOnJobType = getLookupMappings(this.lookupMappingInfo, 'YearsOnJobType');
    this.monthsOnJobType = getLookupMappings(this.lookupMappingInfo, 'MonthsOnJobType');
    this.incomePeriodIntervalType = getLookupMappings(this.lookupMappingInfo, 'IncomePeriodIntervalType');
    this.employmentTypeEnumForMappingToJobType = getLookupMappings(this.lookupMappingInfo, 'EmploymentTypeEnum');

    this.previousEmploymentInfoForm = this.fb.group({
      PrevEmploymentStatus: [this.employment.employmentStatus, [Validators.required]],
      PrevEmploymentType: [this.employment.jobType || '', [Validators.required]],
      PrevEmployerName: [this.employment.employerName, [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,25}')]],
      PrevJobTitle: [this.employment.jobTitle, [Validators.required, Validators.pattern(this.wordOnlyRegexp + '{0,50}')]],
      PrevEmployerPhone: [this.PhoneNumberUpdate(this.employment.phoneNumber), [Validators.required,
                          Validators.pattern(this.phonePattern)]],
      PrevEmployerDurationGroup: this.fb.group({
        PrevTotalYears: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' : this.employment.yearsAtEmployer, [Validators.required]],
        PrevTotalMonths: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' : this.employment.monthsAtEmployer, [Validators.required]]
      }, { validator: validateBothNotZero }),
      PrevRetiredDurationGroup: this.fb.group({
        PrevTotalYearsRetired: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' : this.employment.yearsAtEmployer],
        PrevTotalMonthsRetired: [this.employment.monthsAtEmployer + this.employment.yearsAtEmployer === 0 ?
           '' : this.employment.monthsAtEmployer]
      }, { validator: validateBothNotZero }),
      PrevGrossSalary: [this.employment.salary || '', [Validators.required]],
      // PrevIncomeFrequency: [this.employment.frequency || '', [Validators.required]]
    });

    // tslint:disable-next-line: no-string-literal
    this.setEmploymentStatusValidators(this.previousEmploymentInfoForm.value['PrevEmploymentStatus'], false);

    this.previousEmploymentInfoForm.get('PrevEmploymentStatus').valueChanges
      .subscribe(employmentStatus => {
        this.setEmploymentStatusValidators(employmentStatus);
      });

    this.numberMask = createNumberMask({
      prefix: ''
    });

    if (this.previousEmploymentInfoForm.valid) {
      this.formSubmitted = true;
      this.previousEmploymentInfoForm.markAsPristine();
    }

    validateAllFormFields(this.previousEmploymentInfoForm);

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.previousEmploymentInfoForm.markAsDirty();
        }
      });
    }
    if(this.isBuyNow){
      if(this.type === StepType.Buyer){
        this.heapIoService.trackPageview('credit-application/previous-employment');
      }
      else  if(this.type === StepType.CoBuyer){
        this.heapIoService.trackPageview('credit-application/cobuyer-previous-employment');
      }

    }

  }

  setEmploymentStatusValidators(employmentStatus: string, resetRetiredTime = true) {
    const prevTotalYearsControl = this.previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears');
    const prevTotalMonthsControl = this.previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths');
    const prevTotalYearsRetiredControl = this.previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired');
    const prevTotalMonthsRetiredControl = this.previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired');
    const prevEmploymentTypeControl = this.previousEmploymentInfoForm.get('PrevEmploymentType');
    const prevEmployerNameControl = this.previousEmploymentInfoForm.get('PrevEmployerName');
    const prevJobTitleControl = this.previousEmploymentInfoForm.get('PrevJobTitle');
    const prevEmployerPhoneControl = this.previousEmploymentInfoForm.get('PrevEmployerPhone');

    if (employmentStatus === 'Retired') {

      prevTotalYearsRetiredControl.setValidators([Validators.required]);
      prevTotalMonthsRetiredControl.setValidators([Validators.required]);
      prevEmploymentTypeControl.setValidators(null);
      prevEmployerNameControl.setValidators(null);
      prevJobTitleControl.setValidators(null);
      prevEmployerPhoneControl.setValidators(null);
      prevTotalYearsControl.setValidators(null);
      prevTotalMonthsControl.setValidators(null);

      if (resetRetiredTime) {
        prevTotalYearsRetiredControl.reset();
        prevTotalMonthsRetiredControl.reset();
      }

      prevTotalYearsControl.reset();
      prevTotalMonthsControl.reset();
      prevEmploymentTypeControl.reset();
      prevEmployerNameControl.reset();
      prevJobTitleControl.reset();
      prevEmployerPhoneControl.reset();

      this.isCustomerRetired = true;
      // tslint:disable-next-line: no-string-literal
    } else if (this.previousEmploymentInfoForm.value['PrevEmploymentStatus'] === 'Retired') {

      prevTotalYearsRetiredControl.setValidators(null);
      prevTotalMonthsRetiredControl.setValidators(null);
      prevEmploymentTypeControl.setValidators([Validators.required]);
      prevEmployerNameControl.setValidators([Validators.required]);
      prevJobTitleControl.setValidators([Validators.required]);
      prevEmployerPhoneControl.setValidators([Validators.required]);
      prevTotalYearsControl.setValidators([Validators.required]);
      prevTotalMonthsControl.setValidators([Validators.required]);

      prevTotalYearsRetiredControl.reset();
      prevTotalMonthsRetiredControl.reset();
      prevTotalYearsControl.reset();
      prevTotalMonthsControl.reset();
      prevEmploymentTypeControl.reset();
      prevEmployerNameControl.reset();
      prevJobTitleControl.reset();
      prevEmployerPhoneControl.reset();

      this.isCustomerRetired = false;
    }

    prevEmploymentTypeControl.updateValueAndValidity();
    prevEmployerNameControl.updateValueAndValidity();
    prevJobTitleControl.updateValueAndValidity();
    prevEmployerPhoneControl.updateValueAndValidity();
    prevTotalYearsRetiredControl.updateValueAndValidity();
    prevTotalMonthsRetiredControl.updateValueAndValidity();
    prevTotalYearsControl.updateValueAndValidity();
    prevTotalMonthsControl.updateValueAndValidity();
  }

  clearValidations(formControl: AbstractControl) {
    if (formControl.invalid) {
      formControl.reset();
      this.controlCleared(formControl);
    }
  }

  PhoneNumberUpdate(phone) {
    if (phone) {
      let p = phone.match(/\d/g);
      p = p.join('');
      return '(' + p.substr(0, 3) + ') ' + p.substr(3, 3) + '-' + p.substr(6, 4);
    }
    return '';
  }

  controlCleared(formControl) {
    switch (this.getControlName(formControl)) {
      case 'PrevEmployerName':
        this.prevEmployerNameCleared = true;
        break;
      case 'PrevJobTitle':
        this.prevJobTitleCleared = true;
        break;
      case 'PrevEmployerPhone':
        this.prevEmployerPhoneCleared = true;
        break;
      case 'PrevGrossSalary':
        this.prevGrossSalaryCleared = true;
        break;
      // tslint:disable-next-line: no-switch-case-fall-through
      default:
        break;
    }
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent && c.parent.controls;
    return formGroup ? Object.keys(formGroup).find(name => c === formGroup[name]) : null;
  }

  goBack() {
    let currentComponent: IComponentDetails;

    if (this.type === StepType.Buyer) {
      currentComponent = {
        groupName: ComponentGroup.EmploymentInfo,
        component: new StepComponent(PreviousEmploymentInfoComponent,
          ComponentName.PreviousEmploymentInfoComponent, ComponentGroup.EmploymentInfo, true),
        componentName: ComponentName.EmploymentInfoComponent
      };
    } else {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerEmployment,
        component: new StepComponent(PreviousEmploymentInfoComponent,
          ComponentName.CoBuyerPreviousEmploymentInfoComponent, ComponentGroup.CoBuyerEmployment, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerPreviousEmploymentInfoComponent
      };
    }

    this.previousComponentService.loadComponent(currentComponent);
  }

  goNext() {
    let ca:any;
    this.formSubmitAttempt = true;
    this.prevEmployerNameCleared = false;
    this.prevJobTitleCleared = false;
    this.prevEmployerPhoneCleared = false;
    this.prevGrossSalaryCleared = false;
    getBackButton();
    if ((this.previousEmploymentInfoForm.valid && this.previousEmploymentInfoForm.dirty)
    || (this.previousEmploymentInfoForm.valid && !this.formSubmitted)) {
      if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
        ca = { ...this.creditAppService.LegacyCreditApplication };
      }else{
        ca = { ...this.creditAppService.CreditApplication };
      }

        const stepCount = (this.type === StepType.Buyer ? 5 : 11);
        /* istanbul ignore else */
        // if (ca.step <= stepCount || ca.step === 13) {
        ca.step = stepCount;
        // }

        const employmentStatus = this.previousEmploymentInfoForm.get('PrevEmploymentStatus').value;
        ca[this.type].financialInformation.previousEmployer = {
          employerName: this.previousEmploymentInfoForm.get('PrevEmployerName').value,
          employmentStatus,
          // frequency: this.previousEmploymentInfoForm.get('PrevIncomeFrequency').value,
          jobTitle: this.previousEmploymentInfoForm.get('PrevJobTitle').value,
          jobType: this.previousEmploymentInfoForm.get('PrevEmploymentType').value,
          phoneNumber: this.previousEmploymentInfoForm.get('PrevEmployerPhone').value,
          salary: this.previousEmploymentInfoForm.get('PrevGrossSalary').value.replace(/,\s?/g, '').replace(/\b(0(?!\b))+/g, ''),
          yearsAtEmployer: employmentStatus !== 'Retired' ?
            this.previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalYears').value :
            this.previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalYearsRetired').value,
          monthsAtEmployer: employmentStatus !== 'Retired' ?
            this.previousEmploymentInfoForm.get('PrevEmployerDurationGroup.PrevTotalMonths').value :
            this.previousEmploymentInfoForm.get('PrevRetiredDurationGroup.PrevTotalMonthsRetired').value
        };

        this.isSaving = true;
        if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
          ca[this.type].financialInformation.previousEmployer.job = 0;
          ca[this.type].financialInformation.previousEmployer.salary = parseInt( ca[this.type].financialInformation.previousEmployer.salary);
          ca[this.type].financialInformation.previousEmployer.frequency = 0;
          ca[this.type].financialInformation.previousEmployer.yearsAtEmployer = parseInt( ca[this.type].financialInformation.previousEmployer.yearsAtEmployer);
          ca[this.type].financialInformation.previousEmployer.monthsAtEmployer = parseInt( ca[this.type].financialInformation.previousEmployer.monthsAtEmployer);

        }
        this.creditAppService.SaveCreditApp(ca,this.SubPage).subscribe(response => {
          if (response.isSuccess) {
            this.isSaving = false;
            this.formSubmitted = true;
            this.previousEmploymentInfoForm.markAsPristine();
            this.loadNextComponent();
          } else {
            this.isSaving = false;
            this.reportErrorResponse(response);
          }
        }, error => {
          this.isSaving = false;
          this.reportErrorResponse(error);
        });
    } else {
      if (this.previousEmploymentInfoForm.valid) {
        this.loadNextComponent();
      }
    }
  }

  loadNextComponent() {
    let nextComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      nextComponent = {
        groupName: ComponentGroup.AdditionalInfo,
        component: new StepComponent(
          AdditionalInfoComponent,
          ComponentName.AdditionalInfoComponent,
          ComponentGroup.AdditionalInfo,
          true
        ),
        componentName: ComponentName.AdditionalInfoComponent
      };
      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(
          new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.PreviousEmploymentInfoComponent,
            ComponentGroup.EmploymentInfo,
            true,
            this.type
          )
        )
      );
    } else {
      nextComponent = {
        groupName: ComponentGroup.CoBuyerAdditional,
        component: new StepComponent(
          AdditionalInfoComponent,
          ComponentName.CoBuyerAdditionalInfoComponent,
          ComponentGroup.CoBuyerAdditional,
          true,
          StepType.CoBuyer
        ),
        componentName: ComponentName.CoBuyerAdditionalInfoComponent
      };
      this.analyticsEventService.reportAnalyticsEvent(
        new NextCTAClick(
          new StepComponent(
            PreviousEmploymentInfoComponent,
            ComponentName.CoBuyerPreviousEmploymentInfoComponent,
            ComponentGroup.CoBuyerEmployment,
            true,
            this.type
          )
        )
      );
    }
    this.nextComponentService.loadComponent(nextComponent);
    return nextComponent;
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
          new ServerError(new StepComponent(PreviousEmploymentInfoComponent,
                                            ComponentName.PreviousEmploymentInfoComponent,
                                            ComponentGroup.EmploymentInfo, true, this.type),
                                            analyticsErrorResponse));
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }


  @HostListener('window:resize', ['$event'])
  reSize(e) {
    /* istanbul ignore next */
   this.isMobile();
  }

}

